import { h } from '@stencil/core';

const VerifiedTick = () => (
	<svg class="discord-application-tag-verified" aria-label="Verified Bot" aria-hidden="false" width="16" height="16" viewBox="0 0 16 15.2">
		<path d="M7.4,11.17,4,8.62,5,7.26l2,1.53L10.64,4l1.36,1Z" fill="currentColor" />
	</svg>
);

export default VerifiedTick;
